export const createAutofocusSlice = (set) => ({
    autoFocus: false,
    setAutoFocus: (bool) => {
        set({ autoFocus: bool });
    },
});
